export const black = '#000000';
export const scienceBlue = '#0072CE';
export const bluish = '#2e88cc';
export const cobalt = '#206699';
export const doveGray = '#707070';
export const aliceBlue = '#f0f9ff';
export const weirdGreen = '#4cd964';
export const cherry = '#d50032';
export const grayChateau = '#a3a8ae';
export const greyishBrown = '#474747';
export const abbey = '#565961';
export const nevada = '#646b73';
export const xanadu = '#7a7b7a';
export const battleshipGrey = '#7a7c7f';
export const brownGrey = '#888888';
export const brownGreyTwo = '#919191';
export const silverChalice = '#a6a6a6';
export const silver = '#c9c9c9';
export const silverTwo = '#cdcdcd';
export const silverThree = '#bdbdbd';
export const pumice = '#d3d4d3';
export const iron = '#ced4d9';
export const bonJour = '#e6e5e6';
export const porcelain = '#f4f5f6';
export const concrete = '#f2f2f2';
export const concreteTwo = '#f3f3f3';
export const gallery = '#f0f0f0';
export const alabaster = '#f8f8f8';
export const white = '#ffffff';
export const orangeyRed = '#ff3b30';
export const orange = '#f2a900';
export const seashell = '#F1F1F1';
export const cerulean = '#009fda';
export const paleBlue = '#d2e8ff';
export const vividBlue = '#178AE6';
export const prussianBlue = '#002a4d';
export const grey = '#ced4d9';
export const oldLace = '#fdf6e5';
export const carouselPink = '#fae5ea';
export const darkPink = '#c51162';

export const onHoverBackground = alabaster;

export default {
  black,
  scienceBlue,
  bluish,
  cobalt,
  doveGray,
  aliceBlue,
  weirdGreen,
  cherry,
  grayChateau,
  greyishBrown,
  abbey,
  nevada,
  xanadu,
  battleshipGrey,
  brownGrey,
  brownGreyTwo,
  silverChalice,
  silver,
  silverTwo,
  silverThree,
  pumice,
  iron,
  bonJour,
  porcelain,
  concrete,
  concreteTwo,
  gallery,
  alabaster,
  white,
  orangeyRed,
  orange,
  seashell,
  cerulean,
  paleBlue,
  vividBlue,
  prussianBlue,
  grey,
  oldLace,
  carouselPink,
  onHoverBackground,
  darkPink,
};
